import script from "./RcSectionActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcSectionActions.vue?vue&type=script&setup=true&lang=ts"

import "./RcSectionActions.vue?vue&type=style&index=0&id=7dcae011&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcae011"]])

export default __exports__